import Home from "./pages/Home";
import './App.scss'

function App() {
  return (
   <Home/>
  );
}

export default App;
